<div
    class="view-node-description"
    [ngClass]="{
        'view-node-description--layout-column': layout === 'column',
        'view-node-description--layout-drawer': layout === 'drawer'
    }">

    <div class="view-node-description__header">
        <app-pin-button
            size="small"
            icon="arrow-left"
            class="mr-1 mt-1"
            *ngIf="showClose"
            (click)="handleCloseClick()"></app-pin-button>

        <!-- Title -->
        <div class="view-node-description__title">{{ (node$ | async)?.label }}</div>
    </div>

    <!-- Body -->
    <div
        *ngIf="!(querying$ | async)"
        class="view-node-description__body"
        [class.text-italic]="!(node$ | async)?.description"
        [innerHTML]="formatHTML((node$ | async)?.description || 'No description available')">
    </div>
    
    <!-- attribution -->
    <div *ngIf="(node$ | async)?.description" class="view-node-description__attribution">
        Source: <span class="text-italic">Wikipedia</span>
    </div>

</div>